"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[2483],{

/***/ 82527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ UpgradeLargeBlock_UpgradeLargeBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/layout/ScrollableContainer/ScrollableContainer.tsx
var ScrollableContainer = __webpack_require__(71462);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/CheckedList/CheckedList.tsx
var CheckedList = __webpack_require__(90542);
// EXTERNAL MODULE: ./src/components/dataDisplay/ProductCountImage/ProductCountImage.tsx + 6 modules
var ProductCountImage = __webpack_require__(26130);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
;// CONCATENATED MODULE: ./src/compositions/blocks/UpgradeLargeBlock/components/PlanCard/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "{productsPerPeriod, select, 1 {One} 2 {Two} 3 {Three}} per month"
    },
    subscriptionTitle: {
        en: "{productsPerPeriod, select, 1 {One fragrance} 2 {Two fragrances} 3 {Three fragrances}} per month"
    },
    productPrice: {
        en: '<span class="text-h3">{price}</span> / product'
    },
    yourPlan: {
        en: "Your current plan"
    },
    forFirstMonth: {
        en: "for the first month"
    },
    chooseAmount: {
        en: "Choose {productsPerPeriod} scents every month to fit your lifestyle."
    },
    oneBottle: {
        en: "0.27 oz (8 mL) bottle of your choosing."
    },
    renews: {
        en: "Renews at {price}."
    },
    saveLong: {
        en: "Save {percent} (or roughly {save}) per month with this plan."
    },
    off: {
        en: "off"
    },
    save: {
        en: "Save {value} every month"
    },
    choose: {
        en: "Choose {count, plural, one {# fragrance} other {# fragrances}}"
    },
    planName: {
        en: "{productsPerPeriod, select, 1 {Standard} 2 {Premium} 3 {Platinum}}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/blocks/UpgradeLargeBlock/components/PlanCard/images/most-pop-mobile.svg
const most_pop_mobile_namespaceObject = __webpack_require__.p + "images-svg/most-pop-mobile_9db535.svg";
;// CONCATENATED MODULE: ./src/compositions/blocks/UpgradeLargeBlock/components/PlanCard/images/most-pop-desktop.svg
const most_pop_desktop_namespaceObject = __webpack_require__.p + "images-svg/most-pop-desktop_614ccc.svg";
;// CONCATENATED MODULE: ./src/compositions/blocks/UpgradeLargeBlock/components/PlanCard/PlanCard.tsx











const PlanCard = (param)=>{
    let { className, data, isSubscriptionFlow, onClick } = param;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { productsPerPeriod, productPrice, price: planPrice, percentageDiscount: percent, save, discount, selected } = data;
    const discountPlanPriceUSD = discount?.defaultDiscountPrice ? discount?.defaultDiscountPrice / 100 : null;
    const isCouponDiscountExists = discountPlanPriceUSD && discountPlanPriceUSD < planPrice / 100;
    const handleClick = ()=>{
        if (typeof onClick === "function") {
            onClick(data);
        }
    };
    const isOnePerMonth = productsPerPeriod === 1;
    const isMostPopular = productsPerPeriod === 2;
    const price = (0,formatPrice/* default */.Z)(isSubscriptionFlow ? planPrice : productPrice);
    const savePrice = (0,formatPrice/* default */.Z)(save);
    const checkedListItems = isOnePerMonth ? [
        messages.oneBottle
    ] : isSubscriptionFlow ? [
        {
            ...messages.saveLong,
            values: {
                percent,
                save: savePrice
            }
        }
    ] : [
        {
            ...messages.chooseAmount,
            values: {
                productsPerPeriod
            }
        }
    ];
    if (isSubscriptionFlow && isCouponDiscountExists) {
        checkedListItems.push({
            ...messages.renews,
            values: {
                price
            }
        });
    }
    const rootClassName = (0,clsx/* default */.Z)(className, "relative", isMobile ? "pt-80" : isMostPopular ? "pb-12" : "pt-12");
    const cardClassName = (0,clsx/* default */.Z)("relative flex h-full min-h-[462rem] flex-col items-start justify-start bg-white text-left", isMostPopular ? "border-2 border-gold-30 shadow" : "rounded border border-gray-30", isMobile ? "p-24" : "px-24 pb-24 pt-32");
    const isPercentageDiscountVisible = Boolean(!isSubscriptionFlow && percent);
    const buttonTitle = !isSubscriptionFlow && save > 0 ? {
        ...messages.save,
        values: {
            value: savePrice
        }
    } : {
        ...messages.choose,
        values: {
            count: productsPerPeriod
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": `subscriptionPlanProductsPerPeriod_${productsPerPeriod}`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cardClassName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: {
                        ...messages.planName,
                        values: {
                            productsPerPeriod
                        }
                    },
                    style: "sh2",
                    color: "gold-70"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedList/* default */.Z, {
                    className: "mt-16 max-w-336",
                    items: checkedListItems,
                    withCheckmark: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mt-auto",
                    message: {
                        ...messages.productPrice,
                        values: {
                            price
                        }
                    },
                    style: "sh5",
                    html: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative mt-32",
                    children: [
                        isPercentageDiscountVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx/* default */.Z)("absolute right-12 flex h-s80 w-s80 translate-x-full flex-col justify-center rounded-full bg-light-beige text-center text-gold-50", isMobile ? "top-0" : "bottom-0"),
                            "data-testid": "subscriptionPlanDiscount",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-h5",
                                    children: percent
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    message: messages.off,
                                    style: "eye1"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCountImage/* default */.Z, {
                            imageClassName: "h-[133rem] z-1",
                            count: productsPerPeriod,
                            imageType: "flask"
                        })
                    ]
                }),
                selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mb-24 mt-auto w-full",
                    message: messages.yourPlan,
                    style: "eye2",
                    color: "gray-70",
                    align: "center"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "mt-auto",
                    title: buttonTitle,
                    size: 56,
                    fullWidth: true,
                    rightIcon: isMobile ? null : "32/arrow-right",
                    inlineIcon: isMobile ? "32/arrow-right" : null,
                    onClick: handleClick,
                    "data-testid": "subscriptionPlanAction"
                }),
                isMostPopular && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (0,clsx/* default */.Z)("absolute", isMobile ? "bottom-full left-0 mb-16 w-[272rem]" : "right-[80%] top-full mt-[20rem] w-[402rem]"),
                    src: isMobile ? most_pop_mobile_namespaceObject : most_pop_desktop_namespaceObject,
                    alt: "Most popular"
                })
            ]
        })
    });
};
/* harmony default export */ const PlanCard_PlanCard = (/*#__PURE__*/react.memo(PlanCard));

;// CONCATENATED MODULE: ./src/compositions/blocks/UpgradeLargeBlock/messages.ts
/* harmony default export */ const UpgradeLargeBlock_messages = ({
    title: {
        en: "Add more fragrances and save"
    },
    text: {
        en: `
      Upgrade to two or three bottles a month to discover more scents and save money and get perfumes earlier.
      Your queue will refill automatically.
    `
    }
});

;// CONCATENATED MODULE: ./src/compositions/blocks/UpgradeLargeBlock/UpgradeLargeBlock.tsx









const orderClassNameByProductCount = {
    mobile: {
        1: "order-3",
        2: "order-1",
        3: "order-2"
    },
    desktop: {
        1: "order-3",
        2: "order-2",
        3: "order-1"
    }
};
const UpgradeLargeBlock = (props)=>{
    const { className, title, text, plans, isFetching, isSubscriptionFlow, withPadding = true, withBackground = true, withNotification = true, fullWidth = false, showAllPlans = false, onPlanSelect, onConfirm } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const handlePlanSelect = (0,react.useCallback)((plan)=>{
        if (typeof onPlanSelect === "function") {
            onPlanSelect(plan);
        }
        if (!isSubscriptionFlow) {
            (0,manager/* openModal */.h7)("upgradeSubscriptionSummaryModal", {
                planName: plan.name,
                onConfirm: typeof onConfirm === "function" ? ()=>onConfirm(plan) : undefined,
                withNotification
            });
        }
    }, [
        onPlanSelect,
        isSubscriptionFlow,
        onConfirm,
        withNotification
    ]);
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
            h: 400,
            bgColor: "light-beige"
        });
    }
    // By default there should be at least 2 - current and with higher value
    if (!plans || plans.length < 2 && !showAllPlans) {
        return null;
    }
    const itemOrderClassNameMap = isMobile ? orderClassNameByProductCount.mobile : isSubscriptionFlow ? null : orderClassNameByProductCount.desktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)(className, withBackground && "bg-light-beige", !isMobile && `bg-[length:1440rem] bg-[top_center] bg-no-repeat ${fullWidth ? "" : "mx-auto max-w-1440"}`, withPadding && (isMobile ? "py-64" : "pb-96 pt-72")),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: isMobile ? "" : "text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    message: title || UpgradeLargeBlock_messages.title,
                    style: "h4",
                    color: "gold-70"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mx-auto mt-16 max-w-560",
                    message: text || UpgradeLargeBlock_messages.text,
                    style: "p2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer/* default */.Z, {
                    className: (0,clsx/* default */.Z)("mt-40", isMobile ? "snap-x snap-mandatory" : "pb-80"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: isMobile ? "inline-grid auto-cols-[328rem] grid-flow-col gap-16" : "flex justify-center gap-16",
                        children: plans.map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(PlanCard_PlanCard, {
                                className: (0,clsx/* default */.Z)(isMobile ? "snap-start scroll-ml-16" : "max-w-[368rem] flex-1", itemOrderClassNameMap?.[data.productsPerPeriod]),
                                data: data,
                                isSubscriptionFlow: isSubscriptionFlow,
                                onClick: handlePlanSelect
                            }, data.id))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const UpgradeLargeBlock_UpgradeLargeBlock = (UpgradeLargeBlock);


/***/ })

}]);